import { AfterViewInit, Directive, Optional } from '@angular/core';
import { MultiSelect } from 'primeng/multiselect';
import { Select } from 'primeng/select';

@Directive({
  selector: '[appDropDownValueExtender]',
  standalone: false,
})
export class DropDownValueExtenderDirective implements AfterViewInit {
  constructor(
    @Optional() private pDropdown: Select,
    @Optional() private pMultiSelect: MultiSelect,
  ) {}

  ngAfterViewInit(): void {
    if (this.pDropdown) {
      this.pDropdown.getOptionValue = (option: any) => {
        return option;
      };
    }
    if (this.pMultiSelect) {
      this.pMultiSelect.getOptionValue = (option: any) => {
        return option;
      };
    }
  }
}
